export type WorkflowStepId = 'source' | 'passage' | 'relationship' | 'approve' | 'map';

export const researchWorkflow: { id: WorkflowStepId; title: string; body: string }[] = [
  {
    id: 'source',
    title: 'Open a source',
    body: 'Start from a study in your library, with its metadata, sections, and linked passages in one place.',
  },
  {
    id: 'passage',
    title: 'Inspect a supporting passage',
    body: 'Read the exact sentence behind a claim, in context, so nothing is taken on trust.',
  },
  {
    id: 'relationship',
    title: 'Review a proposed relationship',
    body: 'See the connection between two concepts alongside every source that supports or qualifies it.',
  },
  {
    id: 'approve',
    title: 'Approve a finding',
    body: 'Approve, or request changes. Each decision is recorded with reviewer, time, and version.',
  },
  {
    id: 'map',
    title: 'Explore the updated knowledge map',
    body: 'The approved finding joins the map, and stays linked to its evidence wherever it appears.',
  },
];
